import React from 'react';
import { t } from '../../utils/translations';

const SubjectsTab = ({ schoolSubjects, loading, onSubjectClick, userLanguage }) => {
  return (
    <div className="subjects-tab rulee-tab-card">
      <h2 style={{ marginBottom: '1.5rem' }}>{t('schoolClasses', userLanguage)}</h2>
      <p style={{ marginBottom: '1.5rem', color: '#718096' }}>
        {t('subjectsDescription', userLanguage)}
      </p>
      {loading ? (
        <div className="loading">{t('loading', userLanguage)}</div>
      ) : schoolSubjects.length > 0 ? (
        <div className="subjects-grid">
          {schoolSubjects.map((subject, index) => (
            <button
              key={subject.id || index}
              className="subject-card"
              onClick={() => onSubjectClick(subject)}
              disabled={loading}
            >
              <span className="subject-emoji">{subject.emoji}</span>
              <div className="subject-info">
                <h4 className="subject-name">{subject.name}</h4>
                <p className="subject-description">{subject.description}</p>
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>{t('noClassesAssigned', userLanguage)} {t('askParentAssignClasses', userLanguage)}</p>
        </div>
      )}
    </div>
  );
};

export default SubjectsTab;

